import React from "react";
import { Container, Row, Col } from "shards-react";
import ViewProjectSupplier from "../components/project-supplier/ViewProjectSupplier";
import { toast } from "react-toastify";

class ProjectSupplier extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };   
  }

  componentDidMount() {
    if(this.props.location.state){
      this.notify(this.props.location.state.type, this.props.location.state.message);
    }
  }

//this is for showing notification
  notify(type, message) {
		toast(message, {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			type: type,
		});
	}

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        {/* <Row noGutters className="page-header py-4">
          <PageTitle title="" subtitle="" md="12" className="ml-sm-auto mr-sm-auto" />
        </Row> */}
        <Row className="py-3">
          <Col lg="12">
            <ViewProjectSupplier projectId={this.props.match.params.id} notify={this.notify} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ProjectSupplier;
